import { EldmlTransform } from "./EldmlTransform";
import $ from "jquery";

interface DoclinkValue {
  name: string;
  hashLink: string;
}

export class DoclinkTransform extends EldmlTransform {
  apply() {
    this.selector.find("doclink").each((_, element) => {
      // aktualny tag
      const doclink = $(element);

      // pobieramy atrybuty
      let value = doclink.attr("field-value");

      // parsujemy wartość
      let jsonObject: DoclinkValue | undefined = value
        ? JSON.parse(value)
        : undefined;

      // tworzymy link
      const link = document.createElement("a");
      if (jsonObject) {
        link.href = jsonObject.hashLink;
        link.textContent = jsonObject.name;
      }

      // dodajemy link
      doclink.append(link);
    });
  }
}
